import { CompanyProfile } from 'containers/CompanyModule/CompanyProfile'
import { CompanyEFTTab } from './CompanyEFTTab'
import React from 'react'
import { CompanyForm } from 'containers/CompanyModule/CompanyForm'

export const companyEFTRoutes = [
  {
    props: {
      exact: true,
      path: `/bank-eft/:BankEFTID/company-eft-setup`,
    },
    component: <CompanyEFTTab />,
  },
  {
    props: {
      exact: true,
      path: `/bank-eft/:BankEFTID/company-eft-setup/:CompanyID/edit`,
    },
    component: <CompanyForm mode="edit" />,
  },
]

export default companyEFTRoutes
